import React from "react";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

function Footer() {
  const { locale } = useRouter();
  const { t, ready } = useTranslation("common");

  return (
    <footer className="mt-24 border-t border-slate-200/70 bg-white">
      <div className="mx-auto max-w-7xl px-6 py-14 lg:px-8">
        {/* Top row */}
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          {/* Logo / Brand */}
          <div className="space-y-4">
            <Image
              src={
                locale === "de"
                  ? "/logo/fotoboxguru-color-logo.svg"
                  : "/logo/boothscanner-logo.svg"
              }
              width={200}
              height={60}
              alt={locale === "de" ? "FotoboxGuru Logo" : "BoothScanner Logo"}
            />
          </div>

          {/* Links */}
          <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-[minmax(140px,1fr)_minmax(140px,1fr)_minmax(80px,1fr)_auto]">
            {/* Partner */}
            {locale === "de" && (
              <div className="space-y-3">
                <p className="text-sm font-semibold text-slate-900">
                  Für Partner
                </p>
                <ul className="space-y-2 text-sm text-slate-500">
                  <li>
                    <Link
                      href="/partner-login"
                      className="hover:text-slate-900 transition"
                    >
                      Fotobox-Partner Login
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/affiliate-partner-werden"
                      target="_blank"
                      rel="nofollow"
                      className="hover:text-slate-900 transition"
                    >
                      Affiliate-Partner werden
                    </Link>
                  </li>
                </ul>
              </div>
            )}

            {/* Magazin */}
            {locale === "de" && (
              <div className="space-y-3">
                <p className="text-sm font-semibold text-slate-900">
                  Magazin
                </p>
                <ul className="space-y-2 text-sm text-slate-500">
                  <li>
                    <Link
                      href="/magazin"
                      className="hover:text-slate-900 transition"
                    >
                      Alle Artikel
                    </Link>
                  </li>
                </ul>
              </div>
            )}

            {/* Rechtliches */}
            <div className="space-y-3">
              {locale === "de" && (
                <p className="text-sm font-semibold text-slate-900">
                  {t("footer.links")}
                </p>
              )}

              {ready && (
                <ul className="space-y-2 text-sm text-slate-500">
                  <li>
                    <Link
                      href={`/${t("footer.privacy")
                        .toLowerCase()
                        .replace(/\s+/g, "-")}`}
                      rel="nofollow"
                      className="hover:text-slate-900 transition"
                    >
                      {t("footer.privacy")}
                    </Link>
                  </li>

                  {locale === "de" && (
                    <li>
                      <Link
                        href={`/${t("footer.agb").toLowerCase()}`}
                        rel="nofollow"
                        className="hover:text-slate-900 transition"
                      >
                        {t("footer.agb")}
                      </Link>
                    </li>
                  )}

                  <li>
                    <Link
                      href={`/${t("footer.imprint")
                        .toLowerCase()
                        .replace(/\s+/g, "-")}`}
                      rel="nofollow"
                      className="hover:text-slate-900 transition"
                    >
                      {t("footer.imprint")}
                    </Link>
                  </li>
                </ul>
              )}
            </div>

            {/* Payment */}
            {locale === "de" && (
              <div className="space-y-4 lg:justify-self-end">
                <p className="text-sm font-semibold text-slate-900">
                  Zahlungsmethoden
                </p>

                <div className="flex flex-nowrap items-center gap-4">
                  <Image
                    src="/images/paymentLogoVisa.svg"
                    alt="Visa"
                    width={40}
                    height={24}
                  />
                  <Image
                    src="/images/paymentLogoMasterCard.svg"
                    alt="Mastercard"
                    width={36}
                    height={24}
                  />
                  <Image
                    src="/images/paymentLogoKlarna.svg"
                    alt="Klarna"
                    width={44}
                    height={24}
                  />
                  <Image
                    src="/images/paymentLogoPayPal.svg"
                    alt="PayPal"
                    width={48}
                    height={24}
                  />
                </div>

                <p className="text-xs text-slate-400">
                  Bei Buchung über FotoboxGuru.de
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
